import React from 'react';
import styled from 'styled-components';
import { width, space, color, hover } from 'styled-system';
import tag from 'clean-tag';
import FontIcon from './FontIcon';

const StyledButton = styled(tag.button)`
    display: flex;
    align-items: center;
    justify-content: center;

    padding: 0;
    border: 0;

    height: 30px;
    width: 30px;
    line-height: 30px;
    border-radius: 50%;

    transition: all 0.1s;
    color: inherit;

    background-color: rgba(0, 0, 0, 0);
    cursor: pointer;

    &:focus {
        outline: none;
    }

    &:hover {
        opacity: 0.7;
    }

    &:active {
    }

    ${color};
    ${hover};
    ${width};
    ${space};
`;

StyledButton.propTypes = {
    ...color.propTypes,
    ...hover.propTypes,
    ...width.propTypes,
    ...space.propTypes
};

StyledButton.defaultProps = {
    blacklist: ['icon']
};

const IconButton = ({ icon, children, ...props }) => (
    <StyledButton {...props} icon={!children}>
        <FontIcon icon={icon} />
        <span>{children}</span>
    </StyledButton>
);

IconButton.defaultProps = {
    px: 2
};

export default IconButton;



// WEBPACK FOOTER //
// ./src/uic/IconButton.js